import {Component, Input} from '@angular/core';
import {AppSettings} from '../../config/AppSettings';
import {ImageViewerComponent} from '../dialoge/image-viewer/image-viewer.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-badge-icon',
    templateUrl: './badge-icon.component.html',
    styleUrls: ['./badge-icon.component.css']
})
export class BadgeIconComponent {
    @Input() file_id: string;
    public path: string;

    constructor(public dialog: MatDialog) {
        this.path = AppSettings.getRealAPILink();
    }

    openDialog(): void {
        this.dialog.open(ImageViewerComponent, {
            data: {imageUrl: this.path + 'media/' + this.file_id + '/show'}
        });
    }
}
